import { useDraggable } from '@dnd-kit/core'
import { assignInlineVars } from '@vanilla-extract/dynamic'

import * as styles from './ScrollBar.css'
import type { ScrollerController } from './useScrollerController'

export interface ScrollBarProps {
  controller: ScrollerController

  knobRef: React.MutableRefObject<HTMLDivElement | null>
}

const ScrollBar = ({ controller, knobRef }: ScrollBarProps) => {
  const { listeners, setNodeRef } = useDraggable({ id: 'VirtualList' })

  const setKnobRef = (knobEl: HTMLDivElement) => {
    setNodeRef(knobEl)
    // eslint-disable-next-line react-compiler/react-compiler -- UXP-3732 - Fix React Compiler errors
    knobRef.current = knobEl
  }

  return (
    <div
      className={styles.root}
      style={{
        top: controller.trackSpacingY,
        right: controller.trackSpacingX,
        bottom: controller.trackSpacingY,
        width: controller.trackWidth,
      }}
    >
      <div
        ref={setKnobRef}
        className={styles.knob}
        style={{
          width: controller.trackWidth,
          ...assignInlineVars({
            [styles.knobBackgroundVar]: controller.knobBackground,
            [styles.knobBackgroundHoverVar]: controller.knobHoverBackground,
          }),
        }}
        {...listeners}
      />
    </div>
  )
}

export default ScrollBar
